import type React from "react";
import {
  parse_to_bool,
  parse_to_enum,
} from "../../../components/Search/SearchParamPage.tsx";
import {
  type GetIssuesIssueGetQueryParams,
  assetTypeEnum,
  assetUseCaseEnum,
  issueCategoriesEnum,
  issueSeverityEnum,
  statusEnum,
} from "../../../kubb";
import { removeMapBlanks } from "../../../utils/object.tsx";
import { SearchParamParser } from "../../assetRegister/assets/list/AssetListSearchParam.tsx";

interface IssueListSearchParamProps {
  initialState: Partial<GetIssuesIssueGetQueryParams>;
  children: React.ReactNode;
}

export default function IssueListSearchParam(
  props: IssueListSearchParamProps,
): React.ReactElement {
  return (
    <SearchParamParser
      {...props}
      parser={(parsed) =>
        removeMapBlanks({
          asset_type: parse_to_enum(parsed, assetTypeEnum, "asset_type"),
          asset_position_id: parsed.asset_position_id,
          use_case: parse_to_enum(parsed, assetUseCaseEnum, "use_case"),
          group: parsed.group,
          categories: parse_to_enum(
            parsed,
            issueCategoriesEnum,
            "categories",
          )?.sort((a, b) => {
            return a.toString().localeCompare(b.toString());
          }),
          severity: parse_to_enum(parsed, issueSeverityEnum, "severity")?.sort(
            (a, b) => {
              return a.toString().localeCompare(b.toString());
            },
          ),
          status: parse_to_enum(parsed, statusEnum, "status"),
          include_cancelled: parse_to_bool(parsed, "include_cancelled"),
          include_closed: parse_to_bool(parsed, "include_closed"),

          sort: parsed.sort,
          after: parsed.after,
          before: parsed.before,
          max_items: parsed.max_items,
          direction: parsed.direction,
        })
      }
    />
  );
}
